module.exports = __webpack_public_path__ + "img/login.e1a6169f.png";